import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ITopBoardOffer } from "utils/offer";

type TInput = { city: string };
type TOutput = Array<ITopBoardOffer>;

export default class GetTopBoardApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;

  resolveUri({ city }: TInput): string {
    return `/fe-api/top-board/${city}/${Date.now() / 1000 || 0}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return data.offers.map(
      (x: any): ITopBoardOffer => ({
        id: x.id,
        offerTypeId: x.offer_type_id,
        dispositionId: x.disposition_id,
        area: x.acreage,
        rentalPrice: x.price_rental,
        photos: x.photos,
        street: x.street,
        village: x.village,
        villagePart: x.village_part,
        seo: x.seo,
        absoluteUrl: x.absolute_url,
        publishedAt: x.published_at,
        score: x.score,
        adminUrl: x.url_admin,
      }),
    );
  }
}
